import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '@futrli/shared-services';

import image from './images/internal-error.svg';

export const SfaSomethingWentWrongFatalError = () => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'common.something_went_wrong',
      defaultMessage: 'Something went wrong'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.we_could_not_set_up_the_link_right_now',
      defaultMessage: 'We could not set up the link right now.'
    }),
    text: intl.formatMessage({
      id: 'onboarding.sfa.there_was_a_problem_creating_the_link',
      defaultMessage:
        'There was a problem creating the link between Sage for Accountants and Futrli. Come back later and try setting up the link again.'
    })
  };

  return <SfaFatalError image={image} {...text} />;
};
